// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js!./git.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../node_modules/css-loader/dist/cjs.js!../ui/styles.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../node_modules/css-loader/dist/cjs.js!./themes/black.css";
import ___CSS_LOADER_AT_RULE_IMPORT_3___ from "-!../../node_modules/css-loader/dist/cjs.js!./themes/blue.css";
import ___CSS_LOADER_AT_RULE_IMPORT_4___ from "-!../../node_modules/css-loader/dist/cjs.js!./themes/green.css";
import ___CSS_LOADER_AT_RULE_IMPORT_5___ from "-!../../node_modules/css-loader/dist/cjs.js!./themes/pink.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/OpenSans-VariableFont_wdth,wght.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./fonts/OpenSans-Italic-VariableFont_wdth,wght.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./fonts/MaterialSymbolsOutlined.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_4___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: OpenSans;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    font-weight: 300;
    font-variation-settings: "wght" 300;
}

@font-face {
    font-family: OpenSans;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    font-weight: 400;
    font-variation-settings: "wght" 400;
}
@font-face {
    font-family: OpenSans;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    font-style: italic;
}
@font-face {
    font-family: OpenSans;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    font-weight: 500;
    font-variation-settings: "wght" 500;
}
@font-face {
    font-family: OpenSans;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    font-weight: 600;
    font-variation-settings: "wght" 600;
}

@font-face {
    font-family: 'Material Symbols Outlined';
    font-style: normal;
    font-weight: 400;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff2');
}
/*
https://developers.google.com/fonts/docs/material_symbols
https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined 
*/

.icon {
    font-family: 'Material Symbols Outlined';
    font-weight: normal;
    font-style: normal;
    font-size: var(--icon-size);
    line-height: 1;
    letter-spacing: normal;
    text-transform: none;
    display: inline-block;
    white-space: nowrap;
    word-wrap: normal;
    direction: ltr;
    -webkit-font-feature-settings: 'liga';
    -webkit-font-smoothing: antialiased;
}

* {
    margin: 0px;
    padding: 0px;
    border: 0;
    font: inherit;
    font-style: normal;
    font-weight: 400;
    color: var(--color);
}

*, *::before, *::after {
    box-sizing: border-box;
}

image, picture, svg, video {
    display: block;
    max-width: 100%; 
}

*::-webkit-scrollbar {
    width: 5px;
    height: 5px;
    background-color: transparent;
}
*::-webkit-scrollbar-thumb {
    background-color: var(--hover-background);
}
*::-webkit-scrollbar-corner {
    background-color: transparent;
}
* {
    scrollbar-width: thin;
    scrollbar-color: var(--hover-background) transparent;
}

*:focus {
    outline: none !important
}

li {
    list-style: none;
}

button {
    background-color: transparent;
}

html {
    color-scheme: dark light;
}

body {
    font-family: var(--font-family);
    font-size: var(--font-size);
}

strong {
    font-weight: 600;
}

input {
    font-size: 1rem;
    font-weight: 400;
}

svg.drag-image text {
    fill: var(--color);
    font-family: var(--font-family);
    font-size: 13px;
}

section {
    > p {
        padding: .4em 0;
    }
}

.fill-center {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;   
    text-align: center;
    > .center {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 1em;
        text-align: center;
    }
    .icon:first-of-type {
        font-size: 6em;
    }
    .link {
        color: var(--link);
        text-decoration: underline;
        cursor: pointer;
    }
    b {
        background-color: var(--bar-background);
        padding: .2em .5em;
        border-radius: 6px;
        font-weight: 600;
    }
}

.modal-content {
    header {
        font-weight: 600;
        font-size: 1.4em;
        margin-bottom: 1em;
    }
    p {
        padding: .5em 0;
        > em {
            display: block;
            font-weight: 600;
            background-color: var(--bar-background);
            padding: .5em .8em;
            border: 1px solid var(--border-color);
            border-radius: 5px;
            margin: .2em 0;
        }
    }
    strong {
        font-size: 1.1rem;
        font-weight: 600;
    }
    i {
        font-weight: 400;
    }
    > .info {
        margin: .8em 0;
        display: flex;
        align-items: center;
        gap: 1em;
        font-size: .9em;
        background-color: var(--bar-background);
        border: 1px solid var(--dry-primary);
        border-radius: 5px;
        padding: .5em;
        &::before {
            font-family: 'Material Symbols Outlined';
            font-size: 1.8em;
            color: var(--dry-primary);
            content: "info";
        }
    }
}

.dry-menu .attention * {
    color: var(--attention-color);
}

:root {
    --font-family: OpenSans;
    --font-size: 13.5px;
    --icon-size: 14px;
    --background: #fff;
    --color: #040404;
    --bar-background: #ECE7E5;
    --bar-color: #000000;
    --border-color: #E3E2E3; 
    --hover-background: #e9edf9;
    --selected-background: #2551C8;
    --selected-color: #fff;
    --drop-background: #BEBEBE;
    --link: #1976d2;
    --highlight: #4e91fd;

    --attention-color: #C24944;

    --success-bg: #2A3F35;
    --success-color: #67A85E;

    --info-bg: #27334D;
    --info-color: #7094D5;
}

form {
    label {
        display: block;
        margin: 1em 0 .2em 0;
    }
    & input.dry {
        display: block;
        width: 100%;
    }
    & input.dry::placeholder {
        font-weight: 400;
    }
    > p {
        display: flex;
        align-items: center;
        opacity: .6;
        font-size: .9em;
        > .icon {
            margin-right: .4em;
        }
        > a {
            color: var(--link);
        }
    }
}

:root {
    --dry-bg: var(--background);
    --dry-color: var(--color);
    --dry-border-color: var(--border-color);
    --dry-border-width: 1px;
    --dry-border-style: solid;
    --dry-border: var(--dry-border-width) var(--dry-border-style) var(--dry-border-color);
    --dry-border-radius: .6rem;
    --dry-hover-bg: var(--hover-background);
    --dry-primary: var(--primary);
    --dry-primary-highlight-text: var(--background);
    
    --dry-resizer-color: var(--border-color);
    --dry-resizer-width: 4px;
    --dry-progress-color: var(--primary);
    --dry-progress-bg: var(--background);
    --dry-modal-zindex: 1000;
}

&[data-mode="dark"] {
    --dry-tooltip-bg: #000;
    --dry-tooltip-color: #ffffffcc;
    --dry-primary-highlight: #4d5565;
    --dry-modal-fade: #00000060;   
}
&[data-mode="light"] {
    --dry-tooltip-bg: #757575;
    --dry-tooltip-color: #e5e5e5;
    --dry-primary-highlight: #8c9098;
    --dry-modal-fade: #ffffff60; 
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
